import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getSharePointUrl } from '../../actions/DocumentCollaborationActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FCM_BUTTON_STYLES } from '../constants/runtime.constants';
import { getIsFormChangesMode } from '../selectors/common.selectors';
import { getSharePointUrlParams } from '../selectors/runtime.selectors';

const useStyles = makeStyles(FCM_BUTTON_STYLES);

function SSButtonSharePoint({
  label,
  uniqueIdentifier,
  isEditor,
  id,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
}) {
  const classes = useStyles({ isControlAddedFCM });
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const { FileName, Phase, DocId, SequenceNumber } = useFormSelector(getSharePointUrlParams);
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    async function fetchSharePointUrl() {
      const response = await dispatch(
        getSharePointUrl({
          Phase,
          DocId,
          FileName,
          SequenceNumber,
        })
      );

      response && setUrl(response);
    }

    !isEditor && fetchSharePointUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickHandler = () => window.open(url, '_self');

  return !url && !isEditor && !isFormChangesMode ? null : (
    <span
      className={isControlAddedFCM || isControlChangedFCM ? classes.changesModeWrapper : null}
      ui-ta={getUITA('FormCtrl', 'SSButtonSharePoint', uniqueIdentifier)}
      data-ss-id={id}
    >
      <Button
        color="primary"
        variant="secondary"
        style={{ minWidth: '128px' }}
        onClick={onClickHandler}
        disabled={isEditor || !url || isControlHiddenFCM}
      >
        {translateString(label || 'Collaborate in SharePoint')}
      </Button>
      {isControlChangedFCM && (
        <span className={classes.changesIcon}>
          <ControlChangesIcon id={id} />
        </span>
      )}
    </span>
  );
}

export default SSButtonSharePoint;
